import Tastet from '../tastet.js';
import Template from '../modules/template.js';
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import GoogleMap from '../modules/google-map.js';
import { configure, refinementList, infiniteHits, sortBy, geoSearch } from 'instantsearch.js/es/widgets';

const API_KEY = 'QJN6K40M7C';
const API_SECRET = '365e80fa1c80f680f952fb81b52508b4';

const BLOCK_TYPES = {
  FILTER: 'filter',
  RESULTS: 'results',
  SORT: 'sortBy',
  MAP: 'map',
};

const CLASSES = {
  IS_EMPTY: 'is-empty',
  NO_RESULTS: 'search--no-results',
};

export default class Search extends Tastet.View {
  preload(done) {
    if (this.$element.find('[data-search="map"]').length) {
      new GoogleMap(done);
    } else {
      done();
    }
  }

  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      minChar: 2,
    });

    this.$search = this.$element.is('input') ? this.$element : this.$element.find('input[type="search"]');
    this.$submit = this.$element.find('[type="submit"]');
    this.$sortBy = this.$element.find('select.ais-SortBy-select');

    if (!this.$search.length) {
      return; // this.warn('The Search input couldn\'t be found. Fix the selector when calling "new Search()"');
    }

    // Find the element to host the algolia data
    this.blocks = this.$element.find('[data-search]').map(true, function (el) {
      var data = el.data();
      var type = data.search;
      delete data.search;

      return {
        element: el,
        type: type,
        data: data,
        template: new Template(el, { empty: true }),
        items: [],
      };
    });

    // Algolia
    this.client = algoliasearch(API_KEY, API_SECRET);
    this.search = instantsearch({
      indexName: Tastet.settings.env,
      searchClient: this.client,
      searchFunction: helper => {
        this._reset();

        // Ensure we only trigger a search when there's a query
        helper.state.query && helper.search();

        this.render();
      },
    });

    this.search.on('render', () => this.render());

    // add the widgets
    var widgets = [];

    var regionFilter = Tastet.settings.region ? ' AND (region:' + Tastet.settings.region + ' OR region:all)' : '';
    var conf = configure({
      clickAnalytics: true,
      distinct: true,
      filters: 'lang:' + Tastet.settings.lang + regionFilter,
    });
    widgets.push(conf);

    this.each(this.blocks, block => {
      var w;

      if (block.type === BLOCK_TYPES.FILTER) {
        w = refinementList({
          container: block.template.$parent.get(0),
          attribute: block.data.filter,
          templates: {
            item: item => {
              return block.template.html(item);
            },
          },
        });
      } else if (block.type === BLOCK_TYPES.SORT) {
        w = sortBy({
          container: block.template.$parent.get(0),
          items: block.data.sort_by,
        });
      } else if (block.type === BLOCK_TYPES.MAP) {
        w = geoSearch({
          container: block.template.$parent.get(0),
          googleReference: window.google,
        });
      } else if (block.type === BLOCK_TYPES.RESULTS) {
        w = infiniteHits({
          container: block.template.$parent.get(0),
          templates: {
            item: item => {
              return block.template.html(this.changeThumbnailForImageProxy(item), item.type);
            },
            empty: item => {
              return block.template.html(item, 'empty');
            },
            showMoreText: item => {
              return block.template.html(item, 'showMore');
            },
          },
        });
      }
      w && widgets.push(w);
    });

    this.search.addWidgets(widgets).start();
    this._search();
  }

  addEvents() {
    this.on(this.$search, 'input', this.search_onInput);
    this.on(this.$submit, 'click', this.submit_onClick);
    this.on(this.$sortBy, 'change', this.submit_onClick);
  }

  render() {
    if (!this.search) return;

    var last = this.search.helper.lastResults || {};
    var results = last.hits || [];
    var filters = this.each(last.disjunctiveFacets || [], { type: 'object' }, function (v) {
      return {
        $id: v.name,
        $value: v.data,
      };
    });

    // add "is-empty" classes to empty blocks
    this.each(this.blocks, function (block) {
      var isEmpty = false;
      var noResults = false;

      if (block.type === 'filter') {
        isEmpty = this.utils.is.empty(filters[block.data.filter]);
      } else if (block.type === 'results' || block.type === 'map') {
        isEmpty = !results.length;
        noResults = !results.length;
      }

      if (isEmpty) {
        block.element.addClass(CLASSES.IS_EMPTY);
      } else {
        block.element.removeClass(CLASSES.IS_EMPTY);
      }

      if (noResults) {
        this.$element.addClass(CLASSES.NO_RESULTS);
      } else {
        this.$element.removeClass(CLASSES.NO_RESULTS);
      }
    });

    this.trigger('render');
    // this.onCheckPlacesFilter(); //If place filter is checked then display filter list
    let filterTypeButton = this.$element.find('button[data-filter-type="type"]');
    this.on(filterTypeButton, 'mouseup', e => this.onClickFilterTypeButton(e));
    this.on(filterTypeButton, 'touchend', e => this.onClickFilterTypeButton(e)); //event on mobile

    this.checkAllWhenNoFilter();
  }

  clear() {
    this.search.helper.clearRefinements();

    this.each(this.blocks, function (block) {
      // for hits, instead of adding the "is_empty", we clear the html
      if (block.type === BLOCK_TYPES.RESULTS) {
        block.template.clear();
      } else {
        block.element.addClass(CLASSES.IS_EMPTY);
      }
    });

    this.trigger('clear');
  }

  // private ---------------------------------------------------------------------------------------------------------
  _reset() {
    for (var i in this.blocks) {
      this.blocks[i].items = [];
    }
  }

  _search() {
    var value = (this.$search.val() || '').trim();
    var length = value.length;

    if (!value || length < this.data.minChar) {
      this.clear();
    } else {
      this.search.helper.setQuery(value).search();
    }
  }

  _html(block, item, type) {
    var tmpl = block.templates[type];
    var html = '';

    if (!tmpl && type) {
      for (var i in block.templates) {
        var t = block.templates[i];
        if (t.data.type) {
          var types = this.utils.toArray(t.data.type);
          if (!~types.indexOf(type)) {
            tmpl = t;
            break;
          }
        }
      }
    }

    tmpl = tmpl || block.templates['*'];

    if (tmpl) {
      html = this.utils.string.replace(tmpl.html || '', item);
    }

    return html;
  }

  // events ----------------------------------------------------------------------------------------------------------
  search_onInput() {
    // clear filters
    this.search.helper.clearRefinements();
    this._search();
  }

  submit_onClick() {
    this._search();
  }

  onCheckPlacesFilter() {
    let addressFilter = this.$element.find('button[data-insights-filter="brand:Adresses"]');
    if (addressFilter.length === 0) {
      //en
      addressFilter = this.$element.find('button[data-insights-filter="brand:Places"]');
    }
    const filterDiv = this.$element.find('.filters--places')[0];
    const li = addressFilter.closest('li.ais-RefinementList-item')[0];
    const isSelected = li?.classList?.contains('ais-RefinementList-item--selected');
    const filterIsHidden = filterDiv.classList.contains('hidden');

    if (isSelected && filterIsHidden) {
      filterDiv.classList.remove('hidden');
    }

    if (!isSelected && !filterIsHidden) {
      filterDiv.classList.add('hidden');
    }
  }

  allFilterButton() {
    let filterTypeButton = this.$element.find('button[data-filter="Tout"]');
    if (filterTypeButton.length === 0) {
      filterTypeButton = this.$element.find('button[data-filter="All"]');
    }
    return filterTypeButton.length !== 0 ? filterTypeButton : null;
  }

  checkAllWhenNoFilter() {
    //Check All when no filter is selected
    let filterTypeButton = this.allFilterButton();
    if (filterTypeButton) {
      const allFilter = filterTypeButton.closest('.ais-RefinementList-item')[0];
      const allFilterClass = 'all-filter';

      const selectedClass = 'ais-RefinementList-item--selected';
      const selectedFilter = this.$element.find('.' + selectedClass);

      if (!allFilter?.classList?.contains(allFilterClass)) {
        allFilter?.classList?.add(allFilterClass);
      }

      const allFilterHasSelectedClass = allFilter?.classList?.contains(selectedClass);
      const allFilterIsSelected = selectedFilter[0]?.classList?.contains(allFilterClass);
      const otherFieldIsSelected = allFilterIsSelected ? selectedFilter.length > 1 : selectedFilter.length > 0;
      const onlyAllFilterIsSelected = allFilterIsSelected && !otherFieldIsSelected;

      if ((selectedFilter.length === 0 || onlyAllFilterIsSelected) && !allFilterHasSelectedClass) {
        allFilter?.classList?.add(selectedClass);
      }

      if (otherFieldIsSelected && allFilterHasSelectedClass) {
        allFilter?.classList?.remove(selectedClass);
      }
    }
  }

  onClickFilterTypeButton(e) {
    const isHumanClick = e.type === 'mouseup' || e.type === 'touchend'; // To avoid action when is a triggered click
    if (isHumanClick) {
      const selectedFilterList = this.$element.find('.ais-RefinementList-item--selected button');

      selectedFilterList.forEach(filter => {
        const dataFilter = filter.getAttribute('data-filter');
        const isAllFilterSelected = dataFilter === 'All' || dataFilter === 'Tout';
        if (!isAllFilterSelected) {
          filter.click();
        }
      });

      const currentFilterButton = e.target;
      const currentDataFilter = currentFilterButton.getAttribute('data-filter');
      const triggerAll = currentDataFilter === 'All' || currentDataFilter === 'Tout';
      const isMobile = window.innerWidth < 769;
      if (triggerAll && !isMobile) {
        currentFilterButton.click();
      }
    }
  }

  changeThumbnailForImageProxy(item) {
    if (item.thumbnail) {
      item.thumbnail = this.wrapUrlInImageProxyUrl(item.thumbnail, 750, 500);
    } else {
      item.thumbnail = Tastet.image_url + 'placeholder.jpg';
    }
    return item;
  }

  wrapUrlInImageProxyUrl(url, width, height) {
    var baseUrl = Tastet.settings.images_proxy_url || null;
    if (!baseUrl) {
      return url;
    }
    var uploadDir = 'wp-content/uploads';
    var path = url.split(uploadDir)[1];
    if (path) {
      return baseUrl + '/_/rs:fit:' + width + ':' + height + ':false:0/plain/local://' + path + '@jpg';
    }
    return url;
  }
}
